// File: /opt/dev_environment/assets/workspace/app-init/src/pages/auth/LoginPage.js

import React, { useState } from 'react';
import { useNavigate, useLocation, Link, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AuthPages.css';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated, isLoading } = useAuth();
  const from = location.state?.from?.pathname || '/';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // If already authenticated, redirect to app
  if (!isLoading && isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login({ email, password });
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Anmeldung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card__header">
          <div className="auth-card__logo">
            <span className="auth-card__logo-icon" role="img" aria-label="Karteikasten">🗃️</span>
            Vokabelkasten
          </div>
          <h2 className="auth-card__title">Anmelden</h2>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && (
            <div className="auth-error" role="alert">
              {error}
            </div>
          )}

          <div className="auth-field">
            <label className="auth-field__label" htmlFor="login-email">
              E-Mail
            </label>
            <input
              id="login-email"
              className="auth-field__input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="deine@email.de"
              autoComplete="email"
              autoFocus
            />
          </div>

          <div className="auth-field">
            <label className="auth-field__label" htmlFor="login-password">
              Passwort
            </label>
            <input
              id="login-password"
              className="auth-field__input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </div>

          <div className="auth-link-row">
            <Link to="/forgot-password" className="auth-link">
              Passwort vergessen?
            </Link>
          </div>

          <button
            className="auth-submit-btn"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="auth-submit-btn__spinner" />
                Wird angemeldet…
              </>
            ) : (
              'Anmelden'
            )}
          </button>
        </form>

        <p className="auth-footer">
          Noch kein Konto?{' '}
          <Link to="/register">Registrieren</Link>
        </p>
      </div>
    </div>
  );
}